import { Tag as PrimeTag, type TagPassThroughOptions } from 'primereact/tag'

export function Tag(props: { tag: string; pt?: TagPassThroughOptions }) {
  return (
    <PrimeTag
      value={props.tag}
      pt={props.pt}
      className='my-[14px] bg-[var(--card-background)] px-[12px] py-[2px] text-[16px] font-normal leading-[30px] text-[var(--primary-color)]'
    />
  )
}
